import { createApp } from 'vue'
import App from './App.vue'
import './index.css'

import { createWebHistory, createRouter } from 'vue-router'

import SignIn from './views/auth/SignIn.vue'
import ForgotPassword from './views/auth/ForgotPassword.vue'
import ResetPassword from './views/auth/ResetPassword.vue'
import DashboardLayout from './layouts/DashboardLayout.vue'
import AuthLayout from './layouts/AuthLayout.vue'

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import { jwtDecode }  from 'jwt-decode';
import LaunchPad from './views/LaunchPad.vue'
import RetailerCatalogue from './views/retailer-catalogue/RetailerCatalogue.vue'
import RetailerPage from './views/retailer-catalogue/RetailerPage.vue'
import OfferPage from './views/retailer-catalogue/OfferPage.vue'

import CashbackLedger from './views/cashback-program/CashbackLedger.vue'
import TransactionEnrichment from './views/monitoring/TransactionEnrichment.vue'
import BankConnections from './views/monitoring/BankConnections.vue'

import BillingPage from './views/monitoring/BillingPage.vue'
import APIPage from './views/integration/APIPage.vue'
import WebhookPage from './views/integration/WebhookPage.vue'
import Webhook from './views/integration/Webhook.vue'
import Playground from './views/integration/Playground.vue'


import ProgramOffers from './views/cashback-program/ProgramOffers.vue'
import PayoutsPage from './views/cashback-program/PayoutsPage.vue'
import Join from './views/auth/Join.vue'
import OfferApprovals from './views/retailer-catalogue/OfferApprovals.vue'

import Settings from './views/dashboard/Settings.vue'



const routes = [
    {
        path: '/',  redirect: '/launchpad', component: DashboardLayout, children:[
            { path: '/launchpad', component: LaunchPad },

            //Cashack program
            { path: '/program-offers', component: ProgramOffers },
            { path: '/cashback-ledger', component: CashbackLedger },
            { path: '/payouts', component: PayoutsPage },

            //Retailer catalogue
            { path: '/retailer-catalogue', component: RetailerCatalogue },
            { path: '/retailer-approvals', component: OfferApprovals },
            
            { path: '/retailer-catalogue/:retailerId', component: RetailerPage },
            { path: '/retailer-catalogue/:retailerId/offer/:offerId', component: OfferPage },

            //Monitoring
            { path: '/transaction-enrichment', component: TransactionEnrichment },
            { path: '/bank-connections', component: BankConnections },
            { path: '/billing', component: BillingPage },

            
            //Integration
            { path: '/api-keys', component: APIPage },
            { path: '/playground', component: Playground },

            { path: '/webhooks', component: WebhookPage },
            { path: '/webhooks/:webhookId', component: Webhook },

            { path: '/settings', component: Settings },
            
            
        ],
        beforeEnter: async (to, from, next) => {
            const token = localStorage.getItem('token')
            if (!token) {
                sessionStorage.setItem('redirectPath', to.path);
                next('/auth/sign-in');
            } else {
                var { exp } = jwtDecode(token);
                var now = Date.now() / 1000;
            
                if(exp < now)
                {
                    sessionStorage.setItem('redirectPath', to.path);
                    next('/auth/sign-in');

                } else
                {
                    next();
                }
            }
        }
    },
    {
        path: '/', component: AuthLayout, children:[
            { path: '/auth/sign-in', component: SignIn },
            { path: '/auth/join/:id', component: Join },
            { path: '/auth/forgot-password', component: ForgotPassword },
            { path: '/auth/reset-password/:id', component: ResetPassword },

        ]
    },
    
  ]

  const router = createRouter({
    history: createWebHistory(),
    routes,
  })


createApp(App).use(router).component('EasyDataTable',Vue3EasyDataTable).mount('#app')
